import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ln',
    fullName: 'Lingala',
    nativeName: 'Lingála',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid oyo ezali na kati",
    landing_title: "Eloko moko ya kokamwa ezali Koya",
    landing_subtitle: "ArgVoid ezali studio ya développement ya app na jeux. Bozala na posa, makambu ya sika ekoya kala mingi te!",
    select_language: "Poná Monoko",
    search_placeholder: "Boluka minoko...",
    terms_title: "Mibeko ya Mosala",
    policy_title: "Politiki ya kobatela makambo ya moto ye moko",
    cookies_title: "Politiki ya Cookies",
    terms_content: `
        <strong>1. Kondima Mibeko</strong><br>
        Soki okɔti na ArgVoid, Mibeko oyo ya Mosala endimami. Soki bayokani na mibeko oyo te, esengeli te kosalela service.<br><br>

        <strong>2. Bosaleli ya plateforme</strong><br>
        ArgVoid mpe ba applications na yango epesami "ndenge ezali" mpo na ntina ya sango mpe ya bokeli. Esengeli kosalela mosala yango kaka mpo na makambo oyo eyokani na mibeko.<br><br>

        <strong>3. Etamboli oyo epekisami</strong><br>
        Kosalela ba vulnérabilités ya site, kosala ba spam, to koluka accès sans autorisation na infrastructure epekisami makasi.<br><br>

        <strong>4. Bozangi mokumba</strong><br>
        Plateforme mpe ba services ekoki ko changer na tango nionso sans préavis. Garantie moko te epesami na oyo etali tango ya kosala to kozala ya service.
    `,
    policy_content: `
        <strong>1. Bosangisi ya sango</strong><br>
        Plateforme esengaka te authentification ya usager to création ya compte na tango oyo. Ba informations moko te ya identification personnelle (lokola ba kombo to ba adresse email) ezuami activement epayi ya ba visiteurs.<br><br>

        <strong>2. Ba Données ya bosaleli</strong><br>
        Ba analyses ya base, anonymes ekoki kosangisama mpo na ko comprendre trafic ya site mpe kobongisa ba applications. Ba données oyo ezali lien te na ba identités ya usager individuel.<br><br>

        <strong>3. Misala ya bato ya misato</strong><br>
        Ba fournisseurs ya troisième partie bakoki kosalelama pona ba services ya hébergement pe ya analyse. Mimeseno ya kobatela makambo ya moto ye moko ya ba fournisseurs respectifs oyo etambwisaka ba données anonymes oyo esalemi na infrastructure na bango.<br><br>

        <strong>4. Bobateli ya ba données</strong><br>
        Ba mesures ya sécurité raisonnable esalemi pona kobatela plateforme. Kasi, lolenge moko te ya kotinda yango na nzela ya Internet ezali mpenza na libateli.<br><br>
    `,
    cookies_content: `
        <strong>1. Ba Cookies mpe Bobombi ya esika ezali nini?</strong><br>
        Ba cookies mpe bobateli ya esika ya navigateur ezali ba fichiers ya ba données ya mike oyo ebombami na dispositif mpo na ko rappeler ba préférences ya configuration na ba visites.<br><br>

        <strong>2. Ntina ya kosalela</strong><br>
        Navigateur LocalStorage esalelamaka na bozindo mpo na kobomba ba paramètres ya configuration, lokola:<br>
        - Ba préférences ya monoko<br>
        - Configuration ya interface ya mosaleli (e.g., ba paramètres ya layout to ya thème)<br>
        - Cache ya application ya tango moke<br><br>

        <strong>3. Kolanda te</strong><br>
        Ba cookie mpe biloko oyo ebombami na esika ofandi esalelamaka te mpo na kosala piblisite to mpo na kolandela bato mosusu. Ba données nionso oyo ebombami ezali strictement pona fonctionnalité ya moboko ya plateforme.<br><br>

        <strong>4. Bokambami</strong><br>
        Ba données ya navigateur ekoki ko effacer na tango nionso na nzela ya ba paramètres ya navigateur, oyo eko réinitialiser ba configurations locales nionso.
    `,
    cookie_consent_text: "Tosalelaka ba cookies ya moboko mpo na kosala ete site Internet esalaka malamu, na ndakisa kobatela session na yo na mosala, kobomba monɔkɔ oyo olingi, mpe ba configurations mosusu oyo olingi.",
    read_policy: "Tanga Politiki ya Cookies",
    support_title: "Bokutana na Lisungi",
    support_subject_label: "Moto ya likambo",
    support_message_label: "Nsango",
    support_submit_button: "Tinda Message",
    support_hint: "Liyebisi: Yango ekofungola application na yo ya email par défaut mpo na kotinda message.",
    support_success_msg: "Kofungola app ya email na yo...",
    support_error_msg: "Elongi te kotinda message. Svp meka lisusu sima.",
    explorer_title: "Explorer",
    history_title: "Lisolo",
    animation_title: "Animation ya bomoi",
    config_title: "Configuration ya kosala",
    tool_mouse: "Pona (Ctrl+M) .",
    tool_brush: "Brosse (Ctrl+B) na .",
    tool_brush_mode: "Mode ya kobongola (Solid/Clear) .",
    tool_eraser: "Effaceur (Ctrl+E) Ezali na .",
    tool_brush_size: "Bongisa Taille ya Brosse",
    tool_bucket: "Tondisa (Ctrl+F) .",
    tool_eyedropper: "Gouttelette ya miso",
    tool_grid: "Grille (Ctrl+Bobongwani+B) .",
    tool_rotate: "Bobalusa (Ctrl+Ebongiseli+R) .",
    tool_flip_h: "Flip H (Ctrl + Bobongwani + H) .",
    tool_flip_v: "Flip V (Ctrl + Bobongwani + V) .",
    tool_transpose: "Transpose (Ctrl + Bobongwani + T) .",
    label_width: "Molai ya moke",
    label_height: "Molai",
    label_frames: "Motango ya ba Cadres",
    label_animation: "Style ya Animation",
    label_background_color: "Couleur ya fond",
    label_interval: "Intervalle oyo ezali na kati",
    tool_anim_config: "Configuration ya ba animation",
    label_new_width: "Largeur ya Sika",
    label_new_height: "Bolai ya Sika",
    label_apply: "Kosalela",
    label_colors: "Ba couleurs",
    label_size: "Bonene",
    label_tolerance: "Kokanga motema",
    val_horizontal: "Ya kolala",
    val_vertical: "Ya kotelema",
    val_sequence: "Ndenge esalemaka",
    val_bounce: "Kozongela",
    val_random: "Kaka ndenge wana",
    val_solid: "Makasi",
    val_clear: "Polele",
    action_add_sheet: "Lokasa ya Sika",
    action_import: "Komema",
    action_export: "Kotinda",
    action_sort_projects: "Kotya na molongo",
    sort_date_old: "Ya kala Ya liboso",
    sort_date_new: "Ya sika Ya liboso",
    sort_name_az: "Kombo (A-Z) .",
    sort_name_za: "Kombo (Z-A) .",
    action_new_sprite: "Sprite ya sika",
    action_new_project: "Projet ya sika",
    modal_save_all_title: "Bomba Mbongwana Nyonso",
    modal_save_all_desc: "Pona biloko oyo okobomba:",
    modal_save_selected: "Bomba Eponami",
    action_saved: "Ebombami",
    modal_create_sprite_title: "Bosala Sprite ya Sika",
    modal_create_project_title: "Bosala Projet ya Sika",
    modal_add_sheet_title: "Bakisa Lokasa ya Sika",
    modal_rename_sheet_title: "Bobongola nkombo ya Lokasa",
    modal_rename_sprite_title: "Bobongola nkombo ya Sprite",
    modal_delete_sprite_title: "Bolongola Sprite",
    modal_delete_project_title: "Bolongola Projet",
    modal_delete_sheet_title: "Bolongola Lokasa",
    placeholder_sprite_name: "Nkombo",
    placeholder_project_name: "Nkombo",
    placeholder_sheet_name: "Nkombo",
    placeholder_new_name: "Kombo ya Sika",
    action_create: "Kosala",
    action_add: "Kobakisa",
    action_rename: "Bobongola nkombo",
    action_duplicate: "Kosala ba doublons",
    action_delete: "Boma",
    action_cancel: "Kolongola",
    confirm_delete_sprite: "Ozali sûr que olingi o supprimer sprite oyo?",
    confirm_delete_project: "Ozali sûr que olingi o supprimer projet oyo? Ba sprites nionso ekolongolama.",
    confirm_delete_sheet: "Ozali sûr que olingi o supprimer lokasa oyo?",
    err_select_sprite: "Svp pona nanu sprite moko.",
    err_select_project: "Svp pona nanu projet moko.",
    err_name_empty: "Nkombo ekoki kozala mpamba te.",
    err_sprite_exists: "Sprite moko na kombo wana eza déjà.",
    err_project_exists: "Projet moko na kombo wana eza déjà.",
    err_no_content: "Contenu te ya kobomba.",
    err_no_changes: "Mbongwana moko te mpo na kobomba.",
    err_delete_last_sheet: "Ekoki te ko effacer lokasa ya suka.",
    err_extract_frames: "Ekokaki kobimisa ata cadre moko te.",
    err_indexeddb: "Elongi te kobomba na esika ofandi. Navigateur na yo ekoki kosimba IndexedDB te.",
    msg_upload_success: "Upload elongi: {0}",
    msg_upload_failed: "Upload elongi te: {0}",
    msg_save_success: "Bomba elonga.",
    msg_saving: "Kobomba...",
    msg_multi_save_result: "Biloko ya {0} oyo ebombami. {1} ba échecs.",
    menu_title: "Menu ya menu",
    menu_save: "Kobikisa",
    menu_save_all: "Bomba Nyonso",
    menu_support: "Bokutana na Lisungi",
    label_local_storage: "Bobombi ya esika",
    label_sign_in: "Kokota na site",
    modal_export_title: "Exporter Sprite na mboka mopaya",
    label_filename: "Nkombo ya fisyé",
    label_format: "Format ya kosala",
    action_export_confirm: "Kotinda",
};

export default translations;
